import { takeEvery } from 'redux-saga/effects';
import { PUSH_NOTIFICATION_SUBSCRIBE } from './types';

/**
 * Subscribe user to push notifications.
 *
 * See https://developer.clevertap.com/docs/web#section--requesting-user-permissions-
 * The default 1-week "notify again" is used.
 *
 * This is an example of saga handling pure side effects.
 *
 * @param {Object} action `PUSH_NOTIFICATION_SUBSCRIBE` action
 */
function* pushNotificationSubscribeSaga() {
  clevertap.notifications.push({
    titleText: 'Would you like to receive Push Notifications?',
    bodyText: 'We promise to only send you relevant updates about Moka',
    okButtonText: 'Sure!',
    rejectButtonText: 'No, thanks',
    okButtonColor: '#3C5DAA',
    serviceWorkerPath: '/sw.js',
  });
}

export default function* saga() {
  yield takeEvery(PUSH_NOTIFICATION_SUBSCRIBE, pushNotificationSubscribeSaga);
}
